export default "__VITE_ASSET__DGzyrUEN__"